import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { STATUS } from 'constants/miscConstants';
import AdminService from 'services/AdminService';
import { t } from 'i18next';

const { SUCCESS, ERROR } = STATUS;

export const initialState = {
  loading: false,
  message: '',
  showMessage: false,
  status: SUCCESS,
  data: { companies: [], totalPages: 0, totalCount: 0 },
  filters: {
    pageNumber: 1,
    pageSize: 10,
  },
  submitting: false,
  actionSuccess: false,
};

export const getCompanies = createAsyncThunk('companies/getCompanies', async (data, { rejectWithValue }) => {
  const { queryParams, pageNumber, pageSize } = data;
  try {
    const response = await AdminService.getCompanies(queryParams);
    return { response, pageNumber, pageSize };
  } catch (err) {
    return rejectWithValue(err?.message || 'Something went wrong');
  }
});

export const updateViewerSeats = createAsyncThunk('companies/updateViewerSeats', async ({ id, viewerSeats }, { rejectWithValue }) => {
  try {
    return await AdminService.updateViewerSeats({ id, viewerSeats });
  } catch (err) {
    return rejectWithValue(err?.message || 'Failed to update viewer seats');
  }
});

const setSuccess = (state, message) => {
  state.submitting = false;
  state.status = SUCCESS;
  state.message = message;
  state.showMessage = true;
  state.actionSuccess = true;
};

const setFailure = (state, action) => {
  state.submitting = false;
  state.status = ERROR;
  state.message = action.payload;
  state.showMessage = true;
};

export const companiesSlice = createSlice({
  name: 'companies',
  initialState,
  reducers: {
    hideMessage: (state) => {
      state.message = '';
      state.status = SUCCESS;
      state.showMessage = false;
      state.actionSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCompanies.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCompanies.fulfilled, (state, action) => {
        const { response, pageNumber, pageSize } = action.payload;
        state.data = response || { companies: [], totalPages: 0, totalCount: 0 };
        state.filters.pageNumber = pageNumber;
        state.filters.pageSize = pageSize;
        state.loading = false;
      })
      .addCase(getCompanies.rejected, (state, action) => {
        state.loading = false;
        state.status = ERROR;
        state.message = action.payload;
        state.showMessage = true;
      })

      .addCase(updateViewerSeats.pending, (state) => {
        state.submitting = true;
      })
      .addCase(updateViewerSeats.fulfilled, (state) => {
        setSuccess(state, t('component.companies.message.updated'));
      })
      .addCase(updateViewerSeats.rejected, (state, action) => {
        setFailure(state, action);
      });
  },
});

export const { hideMessage } = companiesSlice.actions;

export default companiesSlice.reducer;
